var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "card",
      attrs: { "aria-label": _vm.name },
      on: {
        click: function ($event) {
          return _vm.$emit("editItem")
        },
        keyup: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.$emit("editItem")
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            )
              return null
            return _vm.$emit("editItem")
          },
        ],
      },
    },
    [
      _c("div", { staticClass: "link" }, [
        _vm.image.imageUrl
          ? _c("div", { staticClass: "image-wrapper" }, [
              _c("img", {
                staticClass: "image",
                attrs: { src: _vm.image.imageUrl, alt: _vm.image.imageAlt },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "main-content" }, [
            _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.name))]),
            _vm._v(" "),
            _vm.description
              ? _c("p", { staticClass: "description" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.formatItemDescription(_vm.description)) +
                      "\n\t\t\t\t"
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer" }, [
            _vm.price
              ? _c("div", { staticClass: "price" }, [
                  _vm._v("$" + _vm._s(_vm.price.toFixed(2))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAlcohol
              ? _c("div", { staticClass: "alcohol-indicator" }, [
                  _c("span", { staticClass: "cart-button-text" }, [
                    _vm._v(" Alcohol "),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icons-section-wrapper" },
              _vm._l(_vm.allergyIcons, function (icon) {
                return _c(
                  "icon-base",
                  {
                    key: icon,
                    staticClass: "icon",
                    attrs: { height: "20", width: "20", iconName: icon },
                  },
                  [_c(icon, { tag: "component" })],
                  1
                )
              }),
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }